import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ButtonComponent } from '@app/components/button/button.component';
import { DialogBase } from '@app/components/dialog/dialog-base';
import { Subscription, interval } from 'rxjs';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { take } from 'lodash';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-game-dialog-ask-r2t',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    AngularSvgIconModule,
    TranslateModule
  ],
  templateUrl: './game-dialog-ask-r2t.component.html',
  styleUrl: './game-dialog-ask-r2t.component.scss',
  host: { class: 'dialog app-game-dialog-ask-r2t' },
  encapsulation: ViewEncapsulation.None
})
export class GameDialogAskR2tComponent extends DialogBase implements OnDestroy {

  countDown_: Subscription
  timer: number

  constructor(@Inject(DIALOG_DATA) public data: {
    time: number,
    yesText: string,
    noText: string,
  }) {
    super()
    this.timer = data.time

    this.countDown_ = interval(1000)
    .pipe(takeUntilDestroyed())
    .subscribe(() => {
      this.timer--

      if (this.timer <= 0) { this.cancel() }
    })
  }

  ngOnDestroy() {
    this.countDown_.unsubscribe()
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.countDown_.unsubscribe()
    this.dialogRef.close();
  }
}
